import React, { useState, useCallback, useEffect } from 'react';
import MarketingSidebar from './MarketingSidebar';
import MarketingChatArea from './MarketingChatArea';
import MarketingEarlyAccess from './MarketingEarlyAccess';
import '../../styles/MarketingGuest.css';

const MarketingGuestLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(window.innerWidth <= 768);
  const [rightPanelOpen, setRightPanelOpen] = useState(false);
  const [rightPanelCollapsed, setRightPanelCollapsed] = useState(false);
  const [chatCollapsed, setChatCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setSidebarCollapsed(window.innerWidth <= 768);
      if (window.innerWidth > 1100) setRightPanelOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNewChat = useCallback(() => {
    window.location.reload();
  }, []);

  const handleCollapseChat = useCallback(() => {
    setChatCollapsed(true);
    setRightPanelCollapsed(false);
  }, []);

  const handleToggleRightPanel = useCallback(() => {
    if (!rightPanelCollapsed) {
      setRightPanelCollapsed(true);
      setChatCollapsed(false);
    } else {
      setRightPanelCollapsed(false);
    }
  }, [rightPanelCollapsed]);

  return (
    <div className="mkt-layout">
      {/* Mobile sidebar overlay */}
      {!sidebarCollapsed && window.innerWidth <= 768 && (
        <div
          className="mkt-sidebar-overlay"
          onClick={() => setSidebarCollapsed(true)}
        />
      )}
      {/* Tablet right panel overlay */}
      {rightPanelOpen && (
        <div
          className="mkt-right-panel-overlay"
          onClick={() => setRightPanelOpen(false)}
        />
      )}

      <MarketingSidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((v) => !v)}
        onNewChat={handleNewChat}
      />

      <div className="mkt-app-content">
        <MarketingChatArea
          collapsed={chatCollapsed}
          rightPanelOpen={rightPanelOpen}
          onMenuClick={() => setSidebarCollapsed((v) => !v)}
          onToggleRightPanel={() => setRightPanelOpen((v) => !v)}
          onCollapseChat={handleCollapseChat}
          onExpandChat={() => setChatCollapsed(false)}
        />

        <MarketingEarlyAccess
          open={rightPanelOpen}
          onClose={() => setRightPanelOpen(false)}
          collapsed={rightPanelCollapsed}
          expanded={chatCollapsed}
          onToggle={handleToggleRightPanel}
        />
      </div>
    </div>
  );
};

export default MarketingGuestLayout;
